export const BROKER_MANAGEMENT_PREFIX = 'BROKER_MANAGEMENT_PREFIX_';
export const SEARCH_REFRESH = BROKER_MANAGEMENT_PREFIX + 'SEARCH_REFRESH';
